<template>
  <div class="tag-test-system">
    <el-row>
      <el-col :span="4">
        <a :href="toolData.manualData.tagTestManualUrl" target="_blank" rel="noopener noreferrer">
          <Button2 type2="1" class="manual-button" msg="マニュアル" />
        </a>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="15">
        <table class="typeB">
          <tr>
            <th>{{ g_getTools02TagCategoryName(toolId) }}名</th>
            <td>
              <div style="padding: 10px">{{ tagData.name }}</div>
              <ValidationErrorMessages :errorMessageList="facebookValidationErrorData.name" />
            </td>
          </tr>
          <tr>
            <th>
              <span>
                <span v-if="
                  toolData.codeKebab === 'facebook-cv' ||
                  toolData.codeKebab === 'tiktok-cv'
                ">ピクセルID</span>
                <span v-else-if="toolData.codeKebab === 'line-cv'">LINE Tag ID</span>
                <span v-else-if="toolData.codeKebab === 'yda-cv'">yahoo_ydn_conv_io</span>
                <span v-else-if="toolData.codeKebab === 'smartnews-cv'">ピクセルタグID</span>
              </span>
            </th>
            <td>
              <div style="padding: 10px">{{ tagData.mediaTagId }}</div>
              <ValidationErrorMessages :errorMessageList="facebookValidationErrorData.mediaTagId" />
            </td>
          </tr>
          <!-- ↓↓ SmartNews Ads（ビジネスID・アクセストークンはピクセルに紐づくビジネスマネージャーのものを使う） ↓↓ -->
          <template v-if="toolData.codeKebab === 'smartnews-cv'">
            <tr>
              <th>ビジネスマネージャー</th>
              <td>
                <div style="padding: 10px">{{ businessManagerData.accountName }}</div>
              </td>
            </tr>
            <tr>
              <th>ビジネスID</th>
              <td>
                <div style="padding: 10px">{{ businessManagerData.accountCode }}</div>
              </td>
            </tr>
            <tr>
              <th>アクセストークン</th>
              <td>
                <div v-if="businessManagerData.accessTokenTail !== ''" style="padding: 10px">
                  登録済み（末尾 …{{ businessManagerData.accessTokenTail }}）
                </div>
                <div v-else style="padding: 10px; color: red">
                  未登録です。ビジネスマネージャーの編集画面で登録してください。
                </div>
              </td>
            </tr>
            <tr>
              <th>CVイベント</th>
              <td>
                <el-select v-model="smartnewsEventName" placeholder="選択してください。" style="width: 340px">
                  <el-option v-for="(smartnewsEventData, index) in smartnewsEventList" :key="index"
                    :label="smartnewsEventData.name + `（${smartnewsEventData.event}）`"
                    :value="smartnewsEventData.event"></el-option>
                </el-select>
                <div class="note">
                  ダミーのクリックIDで1件送ります。実在しないクリックなので、SmartNews Ads の管理画面にCVは計上されません。
                </div>
              </td>
            </tr>
          </template>
          <!-- ↑↑ SmartNews Ads ↑↑ -->
          <tr v-if="toolData.codeKebab !== 'smartnews-cv'">
            <th>
              <span v-if="
                toolData.codeKebab === 'facebook-cv' ||
                toolData.codeKebab === 'tiktok-cv' ||
                toolData.codeKebab === 'line-cv'
              ">アクセストークン</span>
              <span v-else-if="toolData.codeKebab === 'yda-cv'">yahoo_ydn_conv_label</span>
            </th>
            <td>
              <div style="padding: 10px; word-break: break-all">
                {{ tagData.accessToken }}
              </div>
              <ValidationErrorMessages :errorMessageList="facebookValidationErrorData.accessToken" />
            </td>
          </tr>
          <!-- koko -->
          <tr v-if="toolData.codeKebab === 'line-cv'">
            <th>
              <span>CVイベント</span>
            </th>
            <td>
              <el-select v-model="lineEventName" placeholder="選択してください。" style="width: 340px">
                <el-option v-for="(lineEventData, index) in lineEventList" :key="index"
                  :label="lineEventData.name + `（${lineEventData.event}）`" :value="lineEventData.event"></el-option>
              </el-select>
            </td>
          </tr>
          <tr v-if="toolData.codeKebab === 'line-cv' && lineEventName === 'CustomEvent'">
            <th>
              <span>カスタムイベント</span>
            </th>
            <td>
              <el-input v-model="customEventValue" placeholder="カスタムイベント名を入力してください" style="width: 340px"></el-input>
            </td>
          </tr>
          <tr v-if="
            toolData.codeKebab === 'facebook-cv' ||
            toolData.codeKebab === 'tiktok-cv'
          ">
            <th>
              <span>テストコード</span>
            </th>
            <td>
              <el-input v-model="testEventCode" style="width: 30%"></el-input>
              <ValidationErrorMessages :errorMessageList="facebookValidationErrorData.testEventCode" />
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col>
        <div class="button-cover">
          <el-button @click="sendTestEvent" type="success">テスト送信</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="resultData !== null" type="flex" justify="center">
      <el-col :span="15">
        <h4>送信結果</h4>
        <div v-if="resultData.eventReceived === true">送信完了</div>
        <div v-else-if="toolData.codeKebab === 'smartnews-cv' && resultData.errorIssue === 'Authentication failed'">
          アクセストークンが正しくありません。
        </div>
        <div v-else>{{ resultData.errorMessage }}</div>
        <!-- SmartNews Ads への問い合わせに使う -->
        <div v-if="resultData.requestId !== undefined && resultData.requestId !== ''">
          request_id: {{ resultData.requestId }}
        </div>
        <!-- SmartNews Ads は、ビジネスID・ピクセルタグIDが誤っていても「OK」を返すので、送信完了だけでは設定の正しさが分からない -->
        <div v-if="toolData.codeKebab === 'smartnews-cv' && resultData.eventReceived === true" class="note">
          ビジネスID・ピクセルタグIDが誤っていても『送信完了』と表示されます。設定が正しいかは、実際の広告のクリックから成果が上がったあと、SmartNews Ads の管理画面で確認してください。
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button2 from "@/components/Ui/Button2.vue";
import ValidationErrorMessages from "@/components/Ui/ValidationErrorMessages.vue";

export default {
  name: "TagTestSystem",
  components: {
    Button2,
    ValidationErrorMessages,
  },
  props: {
    toolId: String,
    tagId: String,
  },
  data() {
    return {
      // 
      tagData: {
        name: "",
        mediaTagId: "",
        accessToken: "",
      },
      testEventCode: "",
      lineEventName: "Conversion",
      smartnewsEventName: "Purchase",

      // 
      facebookValidationErrorData: {
        mediaTagId: [],
        accessToken: [],
        testCode: [],
      },
      resultData: null,
      customEventValue: "",
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage", "userData"]),
    ...mapGetters("tools02", ["lineEventList", "smartnewsEventList"]),
    toolData() {
      return this.$store.getters["toolData"](this.toolId);
    },
    businessManagerData() {
      // SmartNews Ads のピクセルに紐づくビジネスマネージャー（見つからないときは空で表示する）
      let businessManagerData = {
        accountName: "-",
        accountCode: "-",
        accessTokenTail: "",
      };
      const accountData = this.$store.getters["tools02/accounts"](this.toolId).find(
        (accountData) => accountData.accountId === this.tagData.accountId
      );
      if (accountData !== undefined) {
        businessManagerData = {
          accountName: accountData.accountName,
          accountCode: accountData.accountCode,
          accessTokenTail: accountData.accessTokenTail !== undefined ? accountData.accessTokenTail : "",
        };
      } else {
        // no action.
      }
      return businessManagerData;
    },
  },
  watch: {
    tagId: {
      handler(newTagId) {
        this.tagData = JSON.parse(
          JSON.stringify(
            this.$store.getters["tools02/tagData"](this.toolId, newTagId)
          )
        );
      },
      immediate: true,
    },
  },
  methods: {
    getEventValue() {
      if (this.toolData.codeKebab === 'line-cv') {
        // 
        let eventValue = this.lineEventName;

        // 
        if (this.lineEventName === 'CustomEvent') {
          eventValue = this.customEventValue;
        } else {
          // no action.
        }

        //
        return eventValue;
      } else if (this.toolData.codeKebab === 'smartnews-cv') {
        return this.smartnewsEventName;
      } else {
        return "";
      }
    },
    sendTestEvent() {
      //
      if (this.toolData.codeKebab === "tiktok-cv") {
        if (this.testEventCode !== "") {
          // ok.
        } else {
          alert("テストコードを入力してください。");
          return;
        }
      } else if (this.toolData.codeKebab === "line-cv") {
        if (this.lineEventName !== "") {
          // ok.
        } else {
          alert("CVイベントを選択してください。");
          return;
        }
        if (this.lineEventName === 'CustomEvent' && this.customEventValue === "") {
          alert("カスタムイベント名を入力してください。");
          return;
        }
      } else if (this.toolData.codeKebab === "smartnews-cv") {
        if (this.smartnewsEventName !== "") {
          // ok.
        } else {
          alert("CVイベントを選択してください。");
          return;
        }
      } else {
        // no action.
      }

      //
      if (this.toolData.codeKebab === "facebook-cv") {
        this.sendFacebookTestEvent();
      } else {
        this.sendElseTestEvent();
      }
    },
    sendFacebookTestEvent() {
      //
      let params = new URLSearchParams();
      params.append("pixel_id_for_api", this.tagData.mediaTagId);
      params.append("access_token", this.tagData.accessToken);
      params.append("test_event_code", this.testEventCode);
      this.$axios
        .post(`${this.rt}/l/api/tools02/media/facebook/send-test-pixel-data`, params)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            alert(response.data.message);
            this.resultData = response.data.resultData;
          } else if (response.data.status === 400) {
            this.facebookValidationErrorData = response.data.validationErrorData;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
          }

          // 
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendElseTestEvent() {
      // LINE CVの場合、イベント名を含むconversion_dataを送信
      let params = new URLSearchParams();
      params.append("tool_id", this.toolId);
      params.append("tools02_tag_id", this.tagId);
      if (
        this.toolData.codeKebab === "line-cv" ||
        this.toolData.codeKebab === "smartnews-cv"
      ) {
        const conversionData = {
          event_name: this.getEventValue()
        };
        params.append("conversion_data", JSON.stringify(conversionData));
      } else {
        // no action.
      }
      // SmartNews Ads にはテストコードの入力欄が無いので、テスト送信だと分かる固定の値を送る（送信履歴に残さないため）
      let testEventCode = this.testEventCode;
      if (this.toolData.codeKebab === "smartnews-cv") {
        testEventCode = "test";
      } else {
        // no action.
      }
      params.append("test_event_code", testEventCode);
      this.$axios
        .post(
          `${this.rt}/l/api/tools02/conversion-api/manual-send-conversion-event`,
          params
        )
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            if (response.data.resultData.eventReceived === true) {
              let message =
                "テスト送信をしました。広告管理画面に反映されているか確認ください。";
              if (this.toolData.codeKebab === "line-cv") {
                message = "テスト送信に成功しました。";
              } else if (this.toolData.codeKebab === "smartnews-cv") {
                // 架空のクリックIDで送るので、管理画面には計上されない
                message = "テスト送信に成功しました。（このテストのCVは管理画面には計上されません）";
              } else {
                // no action.
              }
              alert(message);
            } else {
              alert("テスト送信に失敗しました。");
            }
            this.resultData = response.data.resultData;
          } else if (response.data.status === 400) {
            // SmartNews Ads でピクセルに紐づくビジネスマネージャーが見つからないとき等
            alert(response.data.message);
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.note {
  margin-top: 5px;
  font-size: 12px;
  color: #666;
}

.button-cover {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    margin: 0 20px;
  }
}
</style>
